"use client";

import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect } from "react";
import { Button } from "reactstrap";

import { updateUrlForOpenJobSidePanel } from 'src/helpers/job-slide-out';

import { useAppDispatch, useAppSelector } from "src/hooks/redux-hooks";
import { getJobNotes, getServiceRequestNotes } from "src/redux/jobs/api";

const Notes: React.FC = () => {
  const dispatch = useAppDispatch();
  const timeZone = useAppSelector(
    (state) => state?.jobDetails?.data?.timezone,
  ) as string | undefined;
  const type = useAppSelector((state) => state?.jobDetails?.slideOut?.type);
  const _activeTab =
    useAppSelector((state) => state?.jobDetails?.slideOut?.activeTab) ||
    (type === "jobDetails" ? "quotes" : "jobs");
  const isFetchingJobNotes = useAppSelector(
    (state) => state?.jobDetails?.isFetchingNotes,
  );
  const srId = useAppSelector((state) => state?.jobDetails?.slideOut?.srId);
  const customerNotesCount = useAppSelector(
    (state) => state?.jobDetails?.data?.customer_notes_count,
  ) as number | undefined;
  const notes = useAppSelector((state) => state?.jobDetails?.data?.notes);
  const jobId = useAppSelector(
    (state) => state?.jobDetails?.data?.root_node_id,
  ) as string | undefined;
  useEffect(() => {
    if ((customerNotesCount ?? 0) > 0 && isEmpty(notes || [])) {
      if (type === "jobDetails") {
        dispatch(getJobNotes(jobId)({}));
      }
      if (type === "serviceRequestDetails") {
        dispatch(getServiceRequestNotes(srId)({}));
      }
    }
  }, [dispatch, customerNotesCount, jobId, notes, type, srId]);

  return (
    <React.Fragment>
      {(customerNotesCount ?? 0) > 0 ? (
        <div className="notes-outer">
          {Array?.isArray(notes)
            ? notes?.map((note) => (
                <div
                  className={`notes-content ${note?.is_new ? "new-note" : ""}`}
                  key={note?.job_status_note_id}
                >
                  <div className="notes-content-head">
                    {timeZone && note?.created_at ? (
                      <div className="notes-content-time">
                        {moment
                          ?.utc(note?.created_at)
                          ?.tz(timeZone)
                          ?.format("MMM DD, YYYY h:mm A z") || ""}
                      </div>
                    ) : (
                      ""
                    )}
                    {type === "jobDetails" ? (
                      <div className="notes-content-id">
                        Job: #{note?.job_no}
                      </div>
                    ) : (
                      <Button
                        type="button"
                        color="link"
                        onClick={() =>
                          updateUrlForOpenJobSidePanel(
                            note?.job_no ?? "",
                            "jobDetails",
                            note?.root_node_id ?? "",
                            srId ?? "",
                          )
                        }
                      >
                        Job: #{note?.job_no}
                      </Button>
                    )}
                  </div>
                  <div className="notes-content-body">
                    <p>{note?.note}</p>
                    {note?.is_new ? <div className="note-tag">New</div> : ""}
                  </div>
                </div>
              ))
            : ""}
        </div>
      ) : (
        ""
      )}

      {isFetchingJobNotes ? (
        <div className="spinner-outer">
          <span className="spinner-border spinner-border-sm mr-2 d-block" />
        </div>
      ) : (
        ""
      )}
      {!notes?.length && !isFetchingJobNotes ? (
        <div className="no-data mt-3">
          No notes have been submitted for this job
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};
export default Notes;
